import { render, staticRenderFns } from "./PufaAccessSuccess.vue?vue&type=template&id=5f0d2b16&scoped=true"
import script from "./PufaAccessSuccess.vue?vue&type=script&lang=js"
export * from "./PufaAccessSuccess.vue?vue&type=script&lang=js"
import style0 from "./PufaAccessSuccess.vue?vue&type=style&index=0&id=5f0d2b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0d2b16",
  null
  
)

export default component.exports